
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import RadioButton from '@/components/radio-button.vue';
	import PickerDate from '@/components/picker-date.vue';
	import {
		providerSelectItem
	} from '@/api/supplier';
	import {
		handleClipboard
	} from '@/utils/clipboard'
	import UploadImg from '@/components/upload-img.vue';
	import Dialog from '@/components/dialog.vue';
  import {
    financecontractInvoice,
    financeinvoiceManager,
    financecontractInvoiceStatistics,
    financeupLoadInvoice
  } from "@/api/finance"
  @Component({  
    name: '',
    components: {
      PageFooter,
      RadioButton,
      PickerDate,
      UploadImg,
			'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    private loading = false
    private result:any = {}
    private radioType = 1
    private radioList = [
      {value:1,label:'可开票'},
      {value:2,label:'已开票'},
      {value:0,label:'发票管理'},
    ]
    private supplierNameKey = ''
    private orderNo = ''
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private chooselist:any = []
    private allMoney = 0
    private rowmsg:any = {}
    private keywords = ''

    private uploadShow = false
		private filelist:any = []
    private uploading = false

    private mounted () {
      this.getmoney()
      this.gettablelist()
    }
    
    private activated () {
      this.getmoney()
      this.gettablelist()
    }



    private toDetail(row){
      this.$router.push({
        path:'serviceContractDetail',
        query:{
          Id:row.ProviderId,
          Name:encodeURIComponent(row.ProviderName),
          ServiceFee:row.ServiceFee,
          Ids:row.Ids,
          InvoiceState:String(this.radioType)
        }
      })
    }
    private exportFile(type){
      let url = location.origin
      if(type==1){
        url += '/pc/finance/contractInvoiceExport'
        url += '?ContractType=1'
        url += '&InvoiceState=' + this.radioType
        url += '&ProviderName=' + this.supplierNameKey
        url += '&BillNo=' + this.orderNo
      }else{
        url += '/pc/finance/contractInvoiceBillListExport'
        url += '?ContractType=1'
        url += '&InvoiceState=' + this.radioType
        url += '&ProviderName=' + this.supplierNameKey
        url += '&BillNo=' + this.orderNo
      }
      window.open(url)
    }
    private uploadinvoice(row){
      this.rowmsg = row
      this.uploadShow = true
      this.filelist = []
    }
    private async confirmupload(){
      if(!this.filelist||!this.filelist.length){
        this.$message.error('请先选择要上传的文件')
        return
      }
      try{
        this.uploading = true
        let res:any = await financeupLoadInvoice({
          ProviderId:this.rowmsg.Id,
          InvoiceList:this.filelist.map(v=>{
            return {
              InvoiceLinkUrl:v.url,
              InvoiceName:v.name
            }
          })
        })
        if(res.IsSuccess){
          this.$message.success('上传成功')
          this.uploadShow = false
          this.filelist = []
        }
      }finally{
        this.uploading = false
      }
    }
    private uploadSuc(file,num){
      this.filelist = file
    }
    private getCopy(e){
      let text = this.rowmsg.ProviderName+'的开票信息：' + '\n'
					text += '企业名称：' + this.rowmsg.EnterpriseName + '\n'
					text += '企业税号：' + this.rowmsg.EnterpriseTaxNo + '\n'
					text += '企业地址：' + this.rowmsg.EnterpriseAddress + '\n'
					text += '企业电话：' + this.rowmsg.EnterprisePhone + '\n'
					text += '开户银行：' + this.rowmsg.EnterpriseOpenBankAndAccount + '\n'
      handleClipboard(text,e)
    }
    private tocopy(row){
      this.rowmsg = row
      let copy = (this as any).$refs.copy
      copy.click()
    }
    private toinvoice(){
      if(!this.chooselist||!this.chooselist.length){
        this.$message.error('请选择要开具发票的账单')
        return 
      }
      let list = this.chooselist.reduce((val,item)=>{
        return val.concat(item.IdList.map(v=>Number(v)))
      },[])
      this.$router.push({
        name:'invoicemsg',
        query:{
          list:list
        }
      })
    }
    private selectionchange(list){
      // console.log(list)
      this.chooselist = list
      this.allMoney = this.chooselist.reduce((all,v)=>{
        return all+=v.ServiceFee
      },0)
    }
    private changePage(e){
      this.pageNo = e
      this.changeType(this.radioType,e)
    }
    private clearSearch(){
      this.supplierNameKey = ''
      this.orderNo = ''
      this.pageNo = 1
      this.keywords = ''
      this.changeType(this.radioType,1)
    }
    private doSearch(){
      this.pageNo = 1
      this.changeType(this.radioType)
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await financecontractInvoice({
          ContractType:1,
          InvoiceState:this.radioType,
          ProviderName:this.supplierNameKey,
          BillNo:this.orderNo,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
          let table = (this as any).$refs.table
          if(table){
            table.clearSelection()
          }
        }
      }finally{
        this.tableloading = false
      }
    }
    private async getmanageList(){
      try{
        this.tableloading = true
        let res:any = await financeinvoiceManager({
          ProviderName:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private async getmoney(){
      try{
        this.loading = true
        let res = await financecontractInvoiceStatistics({
          ContractType:1
        })
        if(res.IsSuccess){
          this.result = res.Result
        }
      }finally{
        this.loading = false
      }
    }
    private changeType(e,num?:number){
      // console.log(e)
      this.pageNo = num||1
      if(e==2||e==1){
        this.gettablelist()
      }else{
        this.getmanageList()
      }
    }
  }
